































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { BFormCheckbox } from 'bootstrap-vue';
import GenericCard from '@/components/cards/GenericCard.vue';
import { Alert } from '@/components/global_alerts/types';
import { ModalSize } from '@/components/zen_modal/types';

export default Vue.extend({
  name: 'RiskDeleteCard',
  components: {
    BFormCheckbox,
    GenericCard,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    riskElement: {
      type: String,
      default: 'Risk Element',
    },
    successMessage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      confirmed: <boolean>false,
      deleting: <boolean>false,
      alerts: <Alert[]>[],
    };
  },
  computed: {
    ...mapGetters(['csrfToken']),
  },
  async created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
      request: 'request',
    }),
    async confirmDeletion() {
      if (!this.confirmed) {
        return;
      }
      this.deleting = true;
      try {
        await this.request({
          method: 'delete',
          url: this.url,
          defaultErrorHandler: false,
        });
        this.showAlert({
          type: 'success',
          message: this.successMessage,
        });
        this.confirmModal();
      } catch (error) {
        this.showAlert({
          type: error.response.data.type,
          message: error.response.data.message,
        });
      } finally {
        this.deleting = false;
      }
    },
  },
});
